import { oddsUpdateIndicatorClass } from "../../PrePack";
export function handleOddsUpdateAnimation(element) {
    if (element) {
        element.classList.add(oddsUpdateIndicatorClass);
    }
}
//# sourceMappingURL=handleOddsUpdateAnimation.js.map